import styled from 'styled-components'
import { print } from '../styles'
import {
  compose,
  space,
  layout,
  typography,
  color,
  background,
  border,
  shadow,
} from 'styled-system'

const SimpleTableCell = styled.td`
  ${print}
  ${compose(space, typography, color, layout, background, border, shadow)}

  &:first-child {
    padding-left: ${({ theme }) => theme.space.large}px;
  }

  &:last-child {
    padding-right: ${({ theme }) => theme.space.large}px;
  }
`

SimpleTableCell.defaultProps = {
  // padding-top is larger than bottom to make up
  // for the xsmall border-spacing defined by Table
  pt: 'medium',
  pb: 'small',
  px: 'xlarge',
  borderColor: 'neutral.2',
  borderWidth: 'xthin',
  borderTopStyle: 'solid',
  fontSize: 'medium',
}

export default SimpleTableCell
